import { api } from "./client.js";

export interface GroupMember {
  id: string;
  display_name: string;
}
export interface GroupTravelRow {
  id: string;
  member_id: string;
  member_name: string;
  city: string;
  country: string | null;
  country_code: string | null;
  date_from: string;
  date_to: string | null;
  note: string | null;
}
export interface GroupPage {
  group: { name: string; slug: string; member_limit: number };
  members: GroupMember[];
  full: boolean;
  travel: GroupTravelRow[];
}

export interface MyGroup {
  id: string;
  slug: string;
  name: string;
  member_limit: number;
  member_count: number;
}

// localStorage holds the per-group member token so a returning guest keeps identity.
const tokenKey = (slug: string) => `og:member:${slug}`;
export const memberToken = {
  get: (slug: string) => localStorage.getItem(tokenKey(slug)),
  set: (slug: string, token: string) => localStorage.setItem(tokenKey(slug), token),
};

export const groupsApi = {
  // public (no login)
  page: (slug: string) => api.get<GroupPage>(`/api/g/${slug}`),
  join: (slug: string, displayName: string) =>
    api.post<{ member: { id: string; token: string } }>(`/api/g/${slug}/join`, {
      display_name: displayName,
    }),
  addTravel: (
    slug: string,
    token: string,
    t: {
      city: string;
      country?: string;
      country_code?: string;
      date_from: string;
      date_to?: string;
      note?: string;
    },
  ) => api.post<{ id: string }>(`/api/g/${slug}/travel`, { token, ...t }),
  removeTravel: (slug: string, token: string, id: string) =>
    api.del<{ deleted: boolean }>(`/api/g/${slug}/travel/${id}`, { token }),

  // authed (invited users)
  create: (name: string, displayName: string) =>
    api.post<{ slug: string; group_id: string; member: { id: string; token: string } }>(
      "/api/groups",
      { name, display_name: displayName },
    ),
  listMine: () => api.get<{ groups: MyGroup[] }>("/api/groups"),
  remove: (id: string) => api.del<{ deleted: boolean }>(`/api/groups/${id}`),
};
